import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform, MenuController } from '@ionic/angular';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  templateUrl: './site-admin-layout.page.html',
  styleUrls: ['./site-admin-layout.page.scss']
})
export class SiteAdminLayoutPage {

  menus: any = [];
  currentUser: any;
  selectedMenu: any;

  constructor(
    private platform: Platform,
    private translate: TranslateService,
    private router: Router,
    private authService: AuthService,
    public menuController: MenuController
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.translate.setDefaultLang(event.lang);
        this.menus = event.translations.SITEADMINMENUS;
      });

      this.translate.get(['SITEADMINMENUS']).subscribe((data) => {
        this.menus = data.SITEADMINMENUS;
      });

      this.authService.onCurrentUserChange.subscribe(user => {
        this.currentUser = user;
      });
    });
  }

  gotoProfile() {
    this.router.navigate(['site-admin/profile']);
  }
  gotoSiteAdminAppointments() {
    this.router.navigate(['/site-admin/appointments']);
  }
  gotoHome() {
    this.router.navigate(['/site-admin']);
  }
  signout() {
    this.menuController.close();
    this.authService.logout();
  }
  notification() {
    this.router.navigate(['site-admin/notification-list']);
  }

}
